import { z } from "zod";

/**
 * Input for `business.updateIdleLogoutSetting` (GRA-80). `idleLogoutMinutes`
 * is `null` to turn the setting off, or a positive number of minutes to turn
 * it on. v1 always sends the fixed value of 10, but the range allows a
 * future selectable value (5/10/30) without a schema change.
 */
export const UpdateIdleLogoutSettingInput = z.object({
  businessId: z.string().min(1),
  idleLogoutMinutes: z.number().int().min(1).max(120).nullable(),
});
export type UpdateIdleLogoutSettingInput = z.infer<
  typeof UpdateIdleLogoutSettingInput
>;
